/*
 *Filename: /home/codestax/MyMedicine/MyMed_Frontend/src/store/opdPackageState.js *
 *Path: /home/codestax/MyMedicine/MyMed_Frontend                               *
 *Created Date: Tuesday, March 19th 2024, 11:05:49 am                          *
 *Author: Prakersharya                                                         *
 *                                                                             *
 *Copyright (c) 2024 Trinom Digital Pvt Ltd                                    *
 */


 import Fuse from 'fuse.js';
 import { axios_auth_instance_hba_customer, base_axios_instance_hospital_customer } from '../utils/axios_utils';
 const initialState = {
     fetchingData: true,
     fetchedSuccessfuly: false,
     hospitalList: [],
     filterRegions: [],
     filteredHospitalList: [],
     showHospitalList: [],
     fetchingPackageData: true,
     fetchingPackageSuccefully: false,
     packageListPackageFlow: [],
     showPackageListPackageFlow: [],
     filteredPackageListPackageFlow: [],
     filterdSpeciality: [],
     filteredPackageList: [],
 };
 
 const opdPackageState = {
    namespaced: true,  
     state() {
         return initialState;
     },
     getters: {
         getFilteredHospitalList(state) {
             return state.filteredHospitalList;
         },
         getNonFilteredHospitalList(state) {
             return state.hospitalList;
         },
         getPackageListPackageFlow(state) {
             return state.packageListPackageFlow;
         },
         getFilteredDoctorList(state) {
             return state.filteredPackageListPackageFlow;
         },
         getFilteredPackageList(state) {
            return state.filteredPackageList;
        },
        getNonfilteredPackageList(state) {
            return state.packageList;
        },

     },
     mutations: {
        uploadfilteredPackageList(state, packageList) {
            state.filteredPackageList = packageList;
        },
        makeFetchingDataTrue(state) {
             state.fetchingData = true;
         },
         makeFetchingDataFalse(state) {
             state.fetchingData = false;
         },
         makeFetchedSuccessFulyTrue(state) {
             state.fetchedSuccessfuly = true;
         },
         makeFetchingPackageDataTrue(state) {
             state.fetchingPackageData = true;
         },
         makeFetchingPackageDataFalse(state) {
             state.fetchingPackageData = false;
         },
         makeFetchedPackageSuccessFulyTrue(state) {
             state.fetchingPackageSuccefully = true;
         },
         uploadPackageListPackageFlow(state, packageListPackageFlow) {
             state.packageListPackageFlow = packageListPackageFlow;
         },
         uploadHospitalList(state, hospitalList) {
             state.hospitalList = hospitalList;
         },
         uploadFilteredHospitalList(state, hospitalList) {
             state.filteredHospitalList = hospitalList;
         },
         uploadFilteredDoctorList(state, doctorList) {
             state.filteredPackageListPackageFlow = doctorList;
         },
         uploadShowHospitalList(state, hospitalList) {
             state.showHospitalList = hospitalList;
         },
         uploadShowPackageListPackageFlow(state, PackageListPackageFlow) {
             state.showPackageListPackageFlow = PackageListPackageFlow;
         },
         uploadRegionFilter(state, regions) {
             state.filterRegions = regions;
         },
         uploadSpecialityFilter(state, speciality) {
            state.filterdSpeciality = speciality;
        },
         resetState(state) {
             Object.keys(initialState).forEach(key => {
                 state[key] = initialState[key];
             });
         },
     },
     actions: {
         async loadHospitalList(context, payload) {
             try {
                 let apiResponse = null;
                 apiResponse = await axios_auth_instance_hba_customer.get('/package');
                 let hosList = [];
                 hosList = apiResponse.data.hospitalList;
                 context.commit('makeFetchingDataTrue');
                 context.commit('uploadHospitalList', hosList);
                 context.commit('uploadFilteredHospitalList', hosList);
                 context.commit('uploadShowHospitalList', hosList);
                 context.commit('makeFetchingDataFalse');
                 context.commit('makeFetchedSuccessFulyTrue');
             } catch(error) {
                 console.log(error);
             }
         },
         async loadPackageListPackageFlow(context, payload) {
             try {
                 if(context.getters.getPackageListPackageFlow.length != 0) return;
                 let apiResponse = null;
                 apiResponse = await axios_auth_instance_hba_customer.get('/package/allpackage');
                 let packageList = [];
                 packageList = apiResponse.data.packageList;
                 context.commit('makeFetchingPackageDataTrue');
                 context.commit('uploadPackageListPackageFlow', packageList);
                 context.commit('uploadFilteredDoctorList', packageList);
                 context.commit('uploadShowPackageListPackageFlow', packageList);
                 context.commit('makeFetchingPackageDataFalse');
                 context.commit('makeFetchedPackageSuccessFulyTrue');
             } catch(error) {
                 console.log(error);
             }
         },
         searchHospital(context, payload) {
             console.dir(payload, context.getters.getFilteredHospitalList);
             const options = {
                 keys: ['name'],
                 includeScore: true // This can be omitted if the score is not needed
             };
               const fuse = new Fuse(context.getters.getFilteredHospitalList, options);
               let ans = fuse.search(payload.searchQuery).map(result => result.item);
               context.commit('uploadShowHospitalList', ans);
         },
         searchDoctorDoctorFlow(context, payload) {
             console.dir(payload, context.getters.getFilteredDoctorList);
             const options = {
                 keys: ['doctorInfo.doctorNameEN'],
                 includeScore: true // This can be omitted if the score is not needed
             };
               const fuse = new Fuse(context.getters.getFilteredDoctorList, options);
               let ans = fuse.search(payload.searchQuery).map(result => result.item);
               console.log(ans);
               context.commit('uploadShowPackageListPackageFlow', ans);
         },
         searchPackagePackageFlow(context, payload) {
            console.dir(payload, context.getters.getFilteredDoctorList);
            const options = {
                keys: ['packageInfo.packageNameEN', 'packageInfo.packageNameMM', 'packageInfo.tag'],
                includeScore: true // This can be omitted if the score is not needed
            };
              const fuse = new Fuse(context.getters.getFilteredDoctorList, options);
              let ans = fuse.search(payload.searchQuery).map(result => result.item);
              console.log(ans);
              context.commit('uploadShowPackageListPackageFlow', ans);
        },         
         removeSearchQuery(context) {
             context.commit('uploadShowHospitalList', context.getters.getFilteredHospitalList);
         },
         removeSearchQueryDoctor(context) {
             context.commit('uploadShowPackageListPackageFlow', context.getters.getFilteredDoctorList);
         },
         applyRegionFilter(context, payload) {
             context.commit('uploadRegionFilter', payload.regions);
             if(payload.regions.length == 0) {
                 context.commit('uploadFilteredHospitalList', context.getters.getNonFilteredHospitalList)
                 context.commit('uploadShowHospitalList', context.getters.getNonFilteredHospitalList);
             } else {
                 let filteredAns = context.getters.getNonFilteredHospitalList.filter((item) => {
                     console.log(typeof(item.stateID), typeof(payload.regions[0]))
                     console.log(payload.regions.includes(item.stateID));
                     if(payload.regions.includes(Number(item.stateID))) return true;
                     return false;
                 }) 
                 console.log(filteredAns, payload.regions);
                 context.commit('uploadFilteredHospitalList', filteredAns);
                 context.commit('uploadShowHospitalList', filteredAns);
 
             }
         },
         async addPackageSpecialityFilter(context, payload) {
            try {
                let actualPackageList = context.getters.getPackageListPackageFlow;
                let selectedSpecialityIdList = payload.specialities;
                context.commit('uploadSpecialityFilter', selectedSpecialityIdList);
                selectedSpecialityIdList = selectedSpecialityIdList.map((item) => (item.id));
                if (selectedSpecialityIdList.length != 0) {
                    actualPackageList = actualPackageList.filter((item) => (selectedSpecialityIdList.includes(item.packageInfo.category)));
                }
                context.commit('uploadfilteredPackageList', actualPackageList);
                context.commit('uploadShowPackageListPackageFlow', actualPackageList);
            } catch (error) {
                console.log('Error While fetching hospital info', error);
            }
        },
         resetOPDPackageState(context) {
             context.commit('resetState');
         }
     },
 };
 export default opdPackageState;